/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'TemplateThumbnail',

    props: {
        color: {
            type: String,
            default: '#888',
        },

        iconImage: {
            type: String,
            default: undefined,
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-thumbnail" }, [
    _c(
      "svg",
      {
        attrs: {
          viewBox: "0 0 204 131",
          preserveAspectRatio: "xMidYMid slice",
        },
      },
      [
        _c("rect", {
          style: { fill: _vm.color },
          attrs: { width: "204", height: "28" },
        }),
        _c("rect", {
          staticStyle: { fill: "#fff" },
          attrs: { width: "204", height: "103", y: "28" },
        }),
        _c("g", { attrs: { transform: "translate(10, 34)" } }, [
          _c("rect", {
            staticClass: "stroked-rect",
            attrs: { x: "0", y: "0", width: "184", height: "36", rx: "6" },
          }),
          _c("g", { attrs: { transform: "translate(40,6)" } }, [
            _c("rect", {
              staticClass: "skeleton-text",
              attrs: { x: "0", y: "0", width: "108", height: "6" },
            }),
            _c("rect", {
              staticClass: "skeleton-text",
              attrs: { x: "0", y: "12", width: "108", height: "6" },
            }),
            _c("rect", {
              staticClass: "skeleton-text",
              attrs: { x: "118", y: "0", width: "14", height: "14", rx: "4" },
            }),
          ]),
          _c("g", { attrs: { transform: "translate(6, 6)" } }, [
            !_vm.iconImage
              ? _c("g", [
                  _c("rect", {
                    attrs: {
                      fill: _vm.color,
                      x: "0",
                      y: "0",
                      width: "24",
                      height: "24",
                      rx: "4",
                    },
                  }),
                  _c(
                    "g",
                    {
                      staticClass: "logo",
                      attrs: {
                        transform: "translate(13.0, 8.0)",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          staticClass: "group-4",
                          attrs: {
                            transform: "scale(0.8, -0.8) translate(-8, -16)",
                          },
                        },
                        [
                          _c("g", [
                            _c("path", {
                              attrs: {
                                d: "M5.55130435,23.5993043 C7.67024974,24.352679 10.1765343,22.7995826 10.4413273,20.6089795 C10.8114365,18.5692383 9.11302122,16.4869565 7.01978713,16.3736932 C5.10820174,16.1687374 3.24436591,17.6485732 2.9871193,19.5110066 C2.68098783,21.254233 3.84380661,23.0769976 5.55130435,23.5995715",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M8.74852174,13.7572174 C8.74852174,13.7572174 10.0692814,12.4420675 10.1601057,12.321792 C10.0741565,12.2277621 8.77216278,10.734503 8.65556035,10.6438122 L8.74852174,13.7572174 Z M2.54849113,12.321792 C2.63931548,12.4420675 3.96007513,13.7572174 3.96007513,13.7572174 L4.05290296,10.6438122 C3.93696835,10.734503 2.63444035,12.2277621 2.54849113,12.321792 L2.54849113,12.321792 Z M10.8228563,1.70202157 L8.71940452,8.6687833 L12.6888292,12.2062581 C12.3751513,12.5244772 10.110553,14.6971826 9.406464,15.3961962 L6.55698365,15.3961962 L6.15194713,15.3961962 L3.3019993,15.3961962 C2.59837774,14.6971826 0.333312,12.5244772 0.019634087,12.2062581 L3.98952626,8.6687833 L1.88560696,1.70202157 C1.80994226,1.50548035 0.203353043,0.152998957 0.106117565,0.0434086957 L4.4186713,0.0434086957 C5.33933635,5.62683548 6.02038539,7.23789913 6.35449878,7.73409391 C6.68854539,7.23776557 7.36912696,5.62696904 8.29032626,0.0434086957 L12.6023457,0.0434086957 C12.5051103,0.152998957 10.8980536,1.50548035 10.8228563,1.70202157 L10.8228563,1.70202157 Z",
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ])
              : _c(
                  "foreignObject",
                  { attrs: { x: "0", y: "0", width: "24", height: "24" } },
                  [
                    _c("img", {
                      staticClass: "icon-image",
                      attrs: { src: _vm.iconImage, width: "24", height: "24" },
                    }),
                  ]
                ),
          ]),
        ]),
        _c("g", { attrs: { transform: "translate(10, 80)" } }, [
          _c("rect", {
            staticClass: "skeleton-text",
            attrs: { x: "0", y: "0", width: "184", height: "6" },
          }),
          _c("rect", {
            staticClass: "skeleton-text",
            attrs: { x: "0", y: "12", width: "144", height: "6" },
          }),
        ]),
        _c("g", { attrs: { transform: "translate(0, 100)" } }, [
          _c("rect", {
            staticClass: "stroked-rect",
            attrs: { x: "-1", y: "0", width: "206", height: "32" },
          }),
          _c("g", { attrs: { transform: "translate(10,8)" } }, [
            _c("rect", {
              style: { fill: _vm.color },
              attrs: { width: "36", height: "8", x: "0", y: "2", rx: "2" },
            }),
            _c("rect", {
              style: { fill: _vm.color },
              attrs: { width: "24", height: "8", x: "42", y: "2", rx: "2" },
            }),
            _c("rect", {
              style: { fill: _vm.color },
              attrs: { width: "40", height: "16", x: "144", y: "0", rx: "4" },
            }),
          ]),
        ]),
      ]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/webinars/TemplateThumbnail.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__